// Store Import
import store from "../../store";
import { cloneDocumentService } from "../DocumentActions/services";

// Services Imports
import {
  createAssetFolderService,
  getAssetFolderTreeService,
  getAssetStatusListService,
  updateAssetStatusListService,
  deleteAssetStatusService,
  getAssetTagsListService,
  updateAssetTagsListService,
  deleteAssetTagService,
  getAssetFolderContentService,
  getAssetSearchSuggestionService,
  getAssetSearchResults,
  deleteAssetItemsService,
  moveToAssetItemsService,
  renameAssetItemService,
  assetCollaboratorAccessService,
  fetchAssetCollaboratorListService,
  updateAssestStatusService,
  updateAssestTagService,
} from "./assetServices";

// Methods Imports
import {
  getAssetFolderTree,
  generateAssetBreadCrumb,
  updateAssetBreadCrumb,
  updateAssetStoreAfterRename,
  updateAssetStoreAfterDelete,
  updateAssetStoreAfterAddNewitem,
  updateFolderContentWhenTagChange,
  updateAssetStoreAfterMoveToFolder,
  updateFolderContentWhenStatusChange,
  searchSuggestionSplitByType,
  getAssetSearchContentIds,
} from "./assetMethods";
import { prepareStatusMap } from "../KanbanActions/kanbanMethods";
import { swimLaneDragandDropService } from "../PipelineActionsV2/pipelineServices";

export const updateStatusFilters = filters => dispatch => {
  dispatch({
    type: "UPDATE_STATUS_FILTERS",
    payload: filters,
  });
};

export const getAssetFolderTreeAction = () => dispatch =>
  new Promise((resolve, reject) => {
    getAssetFolderTreeService()
      .then(response => {
        dispatch({
          type: "GET_ASSET_FOLDER_TREE",
          payload: getAssetFolderTree(response),
        });
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getAssetFolderContentAction =
  (payload, currentFolderID, assetDataToFetch) => dispatch =>
    new Promise((resolve, reject) => {
      getAssetFolderContentService(payload, assetDataToFetch)
        .then(response => {
          const reduxState = store.getState();
          const { assetFoldersTree } = reduxState.AssetStore;
          let breadCrumbData = [];
          if (assetFoldersTree) {
            breadCrumbData = generateAssetBreadCrumb(
              [
                ...assetFoldersTree.normalFoldersTree,
                ...assetFoldersTree.crmFoldersTree,
              ],
              response,
              assetDataToFetch,
            );
          }
          let assetFolderContentIds = [];
          let currentSelectedFolder = null;
          if (response.page) {
            currentSelectedFolder = {
              id: response.page.id,
              name: response.page.name,
              accessLevel: response.page.access_level,
            };
            if (response.page.inodes && response.page.inodes.length > 0) {
              assetFolderContentIds = response.page.inodes.map(node => node.id);
            }
          }
          const data = {
            assetFolderContent: response,
            assetBreadcrumbData: breadCrumbData,
            assetFolderContentIds,
            currentFolderID,
            currentSelectedFolder,
          };
          dispatch({
            type: "ASSET_FOLDER_CONTENTS",
            payload: data,
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });

export const onscrollexportGetAssetFolderContentAction =
  (payload, currentFolderID, assetDataToFetch, oldContentData) => dispatch =>
    new Promise((resolve, reject) => {
      getAssetFolderContentService(payload, assetDataToFetch)
        .then(response => {
          const reduxState = store.getState();
          const { assetFoldersTree, assetFolderContentIds } =
            reduxState.AssetStore;
          let breadCrumbData = [];
          if (assetFoldersTree) {
            breadCrumbData = generateAssetBreadCrumb(
              [
                ...assetFoldersTree.normalFoldersTree,
                ...assetFoldersTree.crmFoldersTree,
              ],
              response,
              assetDataToFetch,
            );
          }
          const newassetFolderContent = oldContentData;
          if (newassetFolderContent && newassetFolderContent.page) {
            newassetFolderContent.page.count += response.page.count;
            newassetFolderContent.page.has_more = response.page.has_more;
            newassetFolderContent.page.id = response.page.id;
            newassetFolderContent.page.inodes = [
              ...newassetFolderContent.page.inodes,
              ...response.page.inodes,
            ];
            newassetFolderContent.page.name = response.page.name;
            newassetFolderContent.page.page_num = response.page.page_num;
            newassetFolderContent.page.path = response.page.path;
          }
          let NewassetFolderContentIds = [];
          let currentSelectedFolder = null;
          if (response.page) {
            currentSelectedFolder = {
              id: response.page.id,
              name: response.page.name,
              accessLevel: response.page.access_level,
            };
            if (response.page.inodes && response.page.inodes.length > 0) {
              NewassetFolderContentIds = response.page.inodes.map(
                node => node.id,
              );
            }
          }
          const data = {
            assetFolderContent: newassetFolderContent || response,
            assetBreadcrumbData: breadCrumbData,
            assetFolderContentIds: [
              ...assetFolderContentIds,
              ...NewassetFolderContentIds,
            ],
            currentFolderID,
            currentSelectedFolder,
          };
          dispatch({
            type: "ASSET_FOLDER_CONTENTS",
            payload: data,
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });

export const getAssetStatusListAction = () => dispatch =>
  new Promise((resolve, reject) => {
    getAssetStatusListService()
      .then(response => {
        dispatch({
          type: "ASSET_STATUS_LIST",
          payload: { statusList: response },
        });
        // needed for kanban
        dispatch({
          type: "KANBAN_STATUS_MAP",
          payload: prepareStatusMap(response),
        });
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getAssetTagListAction = () => dispatch =>
  new Promise((resolve, reject) => {
    getAssetTagsListService()
      .then(response => {
        dispatch({
          type: "GET_ASSET_TAG_LIST",
          payload: response,
        });
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });

export const createAssetFolderAction = payload => dispatch =>
  new Promise((resolve, reject) => {
    createAssetFolderService(payload)
      .then(response => {
        const reduxState = store.getState();
        const { assetFoldersTree } = reduxState.AssetStore;
        const cloneAssetFoldersTree = updateAssetStoreAfterAddNewitem(
          assetFoldersTree,
          response.folder,
          payload.parent_id,
        );
        dispatch({
          type: "ASSET_CREATE_NEW_FOLDER",
          payload: cloneAssetFoldersTree,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const deleteAssetItemsAction = (payload, selectedItems) => dispatch =>
  new Promise((resolve, reject) => {
    deleteAssetItemsService(payload)
      .then(response => {
        const reduxState = store.getState();
        const {
          assetFoldersTree,
          assetFolderContent,
          assetBreadcrumbData,
          assetFolderContentIds,
        } = reduxState.AssetStore;
        const { folderContent, foldersTree } = updateAssetStoreAfterDelete(
          assetFoldersTree,
          assetFolderContent,
          selectedItems,
        );
        const cloneAssetFolderContentIds = assetFolderContentIds.filter(
          id => !selectedItems.ids.includes(id),
        );
        const data = {
          folderContent,
          foldersTree,
          assetFolderContentIds: cloneAssetFolderContentIds,
          assetBreadcrumbData: updateAssetBreadCrumb(
            assetBreadcrumbData,
            selectedItems,
          ),
        };
        dispatch({
          type: "ASSET_DELETE_ITEMS",
          payload: data,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const moveToAssetItemsAction = (payload, selectedItems) => dispatch =>
  new Promise((resolve, reject) => {
    moveToAssetItemsService(payload)
      .then(response => {
        const reduxState = store.getState();
        const {
          assetFoldersTree,
          assetFolderContent,
          assetBreadcrumbData,
          assetFolderContentIds,
        } = reduxState.AssetStore;
        const { folderContent, foldersTree } =
          updateAssetStoreAfterMoveToFolder(
            assetFoldersTree,
            assetFolderContent,
            selectedItems,
            payload.to,
          );
        const cloneAssetFolderContentIds = assetFolderContentIds.filter(
          id => !selectedItems.ids.includes(id),
        );
        const data = {
          folderContent,
          foldersTree,
          assetFolderContentIds: cloneAssetFolderContentIds,
          assetBreadcrumbData: updateAssetBreadCrumb(
            assetBreadcrumbData,
            selectedItems,
          ),
        };
        dispatch({
          type: "ASSET_MOVE_TO_FOLDER_ITEMS",
          payload: data,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const renameAssetItemAction = (payload, selectedItem) => dispatch =>
  new Promise((resolve, reject) => {
    renameAssetItemService(payload)
      .then(response => {
        const { name } = response.item;
        const reduxState = store.getState();
        const { assetFoldersTree, assetFolderContent, assetBreadcrumbData } =
          reduxState.AssetStore;
        const { folderContent, foldersTree } = updateAssetStoreAfterRename(
          assetFoldersTree,
          assetFolderContent,
          selectedItem,
          name,
        );
        const data = {
          folderContent,
          foldersTree,
          assetBreadcrumbData: updateAssetBreadCrumb(
            assetBreadcrumbData,
            selectedItem,
            name,
          ),
        };
        dispatch({
          type: "ASSET_RENAME_ITEM",
          payload: data,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchAssetCollaboratorListAction = payload => dispatch =>
  new Promise((resolve, reject) => {
    fetchAssetCollaboratorListService(payload)
      .then(response => {
        const filterCollabList = response.filter(
          collab => collab.access_level !== "OWNER",
        );
        dispatch({
          type: "ASSET_ITEM_COLLABORATORS_LIST",
          payload: filterCollabList,
        });
        resolve(filterCollabList);
      })
      .catch(error => {
        reject(error);
      });
  });

export const assetCollaboratorsAccessAction = (payload, type) => dispatch =>
  new Promise((resolve, reject) => {
    assetCollaboratorAccessService(payload, type)
      .then(response => {
        const reduxState = store.getState();
        const { assetItemCollaboratorList } = reduxState.AssetStore;
        let tempCollabList = [...assetItemCollaboratorList];
        // update the collaborator list according to the
        // type (ex: ADD, CHNANGE and "DELETE")
        if (type === "ADD") {
          tempCollabList.push(...response);
        } else if (type === "CHANGE") {
          tempCollabList.forEach(collab => {
            if (collab.user.id === payload.user.id) {
              collab.access_level = payload.access_level;
            }
          });
        } else if (type === "DELETE") {
          tempCollabList = tempCollabList.filter(
            collab => collab.user.id !== payload.user.id,
          );
        }

        dispatch({
          type: "ASSET_ITEM_COLLABORATORS_ACCESS",
          payload: tempCollabList,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateAssestStatusAction = (docId, newStatus) => dispatch =>
  new Promise((resolve, reject) => {
    updateAssestStatusService(docId, newStatus.id)
      .then(res => {
        dispatch({
          type: "UPDATE_ASSET_STATUS",
          payload: { newStatus, docId },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateAssetTagAction = (docId, newTag) => dispatch =>
  new Promise((resolve, reject) => {
    updateAssestTagService(docId, newTag.id)
      .then(res => {
        dispatch({
          type: "UPDATE_ASSET_TAG",
          payload: { newTag, docId },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateAssetStatusListAction = requestBody => dispatch =>
  new Promise((resolve, reject) => {
    updateAssetStatusListService(requestBody)
      .then(response => {
        const reduxState = store.getState();
        const { assetFolderContent } = reduxState.AssetStore;

        const updatedAssetFolderContent = updateFolderContentWhenStatusChange(
          assetFolderContent,
          requestBody,
        );
        dispatch({
          type: "ASSET_STATUS_LIST",
          payload: {
            statusList: response,
            assetFolderContent: updatedAssetFolderContent,
            isUpdate: true,
          },
        });
        // needed for kanban
        dispatch({
          type: "KANBAN_STATUS_MAP",
          payload: prepareStatusMap(response),
        });
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });

export const deleteAssetStatusAction = deleteId => dispatch =>
  new Promise((resolve, reject) => {
    deleteAssetStatusService(deleteId)
      .then(response => {
        dispatch({
          type: "ASSET_STATUS_DELETE",
          payload: {
            deletedStatusId: deleteId,
          },
        });
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateAssetTagsListAction = requestBody => dispatch =>
  new Promise((resolve, reject) => {
    updateAssetTagsListService(requestBody)
      .then(response => {
        const reduxState = store.getState();
        const { assetFolderContent } = reduxState.AssetStore;

        const updatedAssetFolderContent = updateFolderContentWhenTagChange(
          assetFolderContent,
          requestBody,
        );
        dispatch({
          type: "ASSET_TAGS_LIST",
          payload: {
            tagsList: response,
            assetFolderContent: updatedAssetFolderContent,
            isUpdate: true,
          },
        });
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });

export const deleteAssetTagAction = deleteId => dispatch =>
  new Promise((resolve, reject) => {
    deleteAssetTagService(deleteId)
      .then(response => {
        dispatch({
          type: "ASSET_TAG_DELETE",
          payload: {
            deletedTagId: deleteId,
          },
        });
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateAssetSearchSuggestion = searchTerm => dispatch =>
  new Promise((resolve, reject) => {
    getAssetSearchSuggestionService(searchTerm)
      .then(res => {
        dispatch({
          type: "UPDATE_ASSET_SEARCH_SUGGESTIONS",
          payload: {
            assetSearchSuggestions: searchSuggestionSplitByType(res.Inodes),
          },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateAssetSearchContentAction =
  (
    keyword,
    docStatusFilter,
    pageNum = "0",
    sortByDocNum = false,
    sortByStatus = false,
    sortByTags = false,
    sortDesc = false,
  ) =>
  dispatch =>
    new Promise((resolve, reject) => {
      getAssetSearchResults(
        keyword,
        pageNum,
        sortByDocNum,
        sortByStatus,
        sortByTags,
        sortDesc,
        docStatusFilter,
      )
        .then(res => {
          if (res && res.page && res.page.inodes) {
            dispatch({
              type: "UPDATE_ASSET_SEARCH_CONTENT",
              payload: {
                assetSearchContent: res,
                assetSearchContentIds: getAssetSearchContentIds(
                  res.page.inodes,
                ),
                searchTerm: keyword,
              },
            });
          }
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });

export const assetClearSearchTermAction = () => dispatch =>
  dispatch({
    type: "ASSET_CLEAR_SEARCH_TERM_ACTION",
  });

export const updateDocumentList = data => dispatch =>
  new Promise((resolve, reject) => {
    let newinodes = [];
    let newContentIds = [];
    const preDefinedData = {
      id: "",
      parent_id: null,
      object_id: "",
      name: "",
      parent_path: "/",
      parent_name: "",
      type: "",
      file_id: "",
      owner: {},
      modified_by: {},
      created_at: "",
      updated_at: "",
      document_tag: null,
      document_status: {},
      doc_no: "",
      deadline_date: "",
      opportunity_root: false,
      access_level: "",
      stage: "",
    };

    cloneDocumentService(data.items[0].fileId)
      .then(res => {
        const objectId = res.Document.object_id.split("-");
        const newobjectId = `NODE-${objectId[1]}`;
        preDefinedData.id = res.Document.inode_id;
        preDefinedData.object_id = newobjectId;
        preDefinedData.name = res.Document.title;
        preDefinedData.owner = res.Document.created_by;
        preDefinedData.modified_by = res.Document.last_updated_by;
        preDefinedData.created_at = res.Document.created_at;
        preDefinedData.updated_at = res.Document.updated_at;
        preDefinedData.document_status = res.Document.document_status;
        preDefinedData.doc_no = res.Document.doc_no;
        preDefinedData.document_tag = res.Document.document_tag;
        preDefinedData.access_level = data.items[0].accessLevel;
        preDefinedData.file_id = res.Document.id;
        preDefinedData.type = data.items[0].folderType;
        preDefinedData.stage = res.Document.stage;
        const reduxState = store.getState();
        const {
          assetFolderContent,
          assetFolderContentIds,
          assetStatusFilters,
        } = reduxState.AssetStore;
        if (
          assetFolderContent.page &&
          assetFolderContent.page.inodes.length > 0
        ) {
          newinodes = [preDefinedData, ...assetFolderContent.page.inodes];
          newContentIds = [res.Document.inode_id, ...assetFolderContentIds];
          assetFolderContent.page.inodes = newinodes;
        }
        if (
          assetStatusFilters.length === 0 ||
          assetStatusFilters.includes("draft")
        ) {
          dispatch({
            type: "UPDATE_DOCUMENT_LIST",
            payload: {
              assetFolderContentData: assetFolderContent,
              assetFolderContentIdsData: newContentIds,
            },
          });
        }
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const toggleAssetDocumentView = view => dispatch => {
  store.dispatch(updateStatusFilters([]));
  return dispatch({
    type: "TOGGLE_ASSET_DOCUMENT_LIST_VIEW",
    payload: view,
  });
};

export const updateSwimlane = (pipelineId, docId, laneData) => dispatch =>
  new Promise((resolve, reject) => {
    swimLaneDragandDropService(pipelineId, docId, laneData.id)
      .then(res => {
        dispatch({
          type: "UPDATE_ASSET_SWIMLANE",
          payload: { docId, laneData },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateBlockchainOrder =
  (docId, blockchainOrderData) => dispatch => {
    dispatch({
      type: "UPDATE_BLOCKCHAIN_ORDER",
      payload: { docId, blockchainOrderData },
    });
  };
